export enum NotificationType {
  success = 'success',
  error = 'error',
  info = 'info'
}
